<template>
  <div class="content">
    <div class="reset-wrapper">
      <div class="reset">
        <form @submit.prevent="handleVerification" class="form" ref="formContainer">
          <PublicBrandHeader />

          <div class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">Username: </label>
            <input id="username" type="text"
                   v-model="form.username"
                   class="form-control form__input"
                   required>
          </div>

          <div class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">Token: </label>
            <input id="token" type="text"
                   v-model="form.token"
                   class="form-control form__input"
                   required>
          </div>

          <div class="button-group">
            <button type="submit" class="col-md-12 col-12 btn btn--verify">Verify</button>
            <router-link to="/login" class="form__link">Back to login</router-link>
            <div v-bind:class="messageClass" v-html="errorMessage"></div>
            <a class="form__link" @click="handleRequestNewToken">Request New Token</a>
          </div>
        </form>
      </div>

    </div>
  </div>

</template>

<script>
import { 
  verify,
  requestNewToken
} from '@/api/userApi';
import {
  REQUEST_TOKEN_SUCCESS_MESSAGE,
  TOKEN_MISMATCH_MESSAGE,
  TOKEN_EXIPRED_MESSAGE,
  NO_SUCH_USER_MESSAGE
} from '@/api/ajaxActionResponse';
import { 
  post 
} from '@/store/modules/fsm/index';
import {
  LoginNavigation
} from '@/store/modules/fsm/messages';
import router from '@/router/index';
import PublicBrandHeader from '@/components/public-layouts/PublicBrandHeader.vue';
export default {
  name: 'verification-page',
  components: {
    PublicBrandHeader,
  },
  data() {
    return {
      form: {
        username: null, 
        token: null,
      },
      errorMessage: '',
      isTokenExpired: false,
    }
  },
  computed: {
    messageClass: function() {
      return this.errorMessage.length === 0 ? 'd-none' : 'alert alert-warning';
    }
  },
  created() {
    if (this.$route.query['username'] && this.$route.query['token']) {
      this.form.username = this.$route.query['username'];
      this.form.token =this.$route.query['token'];
      this.handleVerification();
    }
  },
  methods: {
    sanitizeForm() {
      for (let key in this.form) {
        this.form[key] = this.form[key].trim();
      }
    },
    handleVerification() {
      //TODO:
      this.sanitizeForm();
      verify(this.form)
      .then((data) => {
        this.isTokenExpired = false;
        this.errorMessage = '';
        alert('Congratulations! Your account has been verified.');
        router.push({name:LoginNavigation});
      })
      .catch((err) => {
        this.errorMessage = err;
      });
    },
    handleRequestNewToken() {
      if (!this.form.username || !this.form.username.trim()) {
        alert('Please enter your username');
        return;
      }
      requestNewToken(this.form.username)
      .then(() => {
        //TODO: move message to ajax response; change message
        alert('Request success, please check your email for new verification code');
        this.isTokenExpired = false;
        // post({message:LoginNavigation});
      
      })
      .catch((err) => {
        console.error(err);
        alert(err);
      });
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../stylesheets/mixins/alignment";
  $color-base: #0060ff;
  .content {
    width: 100%;
    height: auto;
    background: url("../../assets/images/bg.jpg") no-repeat center fixed;     // TODO image subject to copyright
    background-size: cover;
    position: relative;
  }
  .reset-wrapper {
    height: 100vh;
    width: 100%;
    position: relative;
  }

  .reset {
    background-color: #fff;
    padding: 2.0rem;
    -moz-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);

    @include absoluteCenter(380px);
  }
  .reset__introduction {
    color: darken(gray, 10%);
    font-size: 14px;
    text-align: center;
  }
  .btn--verify {
    color: #fff;
    background-color: $color-base;
    &:hover {
      background-color: lighten($color-base, 5%);
    }
  }

  .button-group {
    margin-top: 1.5rem;

    .form__link {
      color: $color-base;
      font-size: 0.85rem;
      margin-top: 0.5rem;
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .form__input {
    font-size: 0.85rem;
  }
  .col-form-label {
    font-size: 14px;
  }

  @media only screen and (max-width: 468px) {
    .reset {
      width: 100%;
    }
  }
</style>
